/**
 * Contains functions commonly used in different js files
 */
class AssessmentHelper {
    public isCorrectAnswer(): boolean {
        const $container = $('.survey-item');
        const $input = $('input', $container);
        if ($input.length === 0) {
            return true; // No input means no answer, hence no correctness to check
        }
        const selectedAnswer = Number($('input:checked', $container).val());
        const correctAnswer = $container.data('correct-answer');
        return correctAnswer === selectedAnswer;
    };
}

export default new AssessmentHelper();
